import { graphql } from '@/generated/gql';

export const INTAKE_ATTACHMENTS_QUERY = graphql(/* GraphQL */ `
  query IntakeAttachments($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        attachments {
          id
          name
          createdAt
          isVisible
        }
      }
    }
  }
`);
